import { Box, Button, CircularProgress } from '@mui/material';
import React, { CSSProperties, useEffect, useState } from 'react';

const FormNavigation: React.FC = () => {
    const [headerList, setHeaderList] = useState<JSX.Element[]>([]);

    const [showNav, setShowNav] = useState(false);

    useEffect(() => {

        setTimeout(() => {
            const cardHeaders = document.querySelectorAll('.MuiCardHeader-root');

            const handleClick = (index: number) => {
                const card = document.querySelectorAll('.MuiCard-root')[index] as HTMLElement;
                const cardRect = card.getBoundingClientRect();
                window.scrollTo({ behavior: 'smooth', top: cardRect.top - 90 });
            };

            const liStyle: CSSProperties = { float: 'left', marginBottom: '-.25em', fontSize: '.5em' };

            const headers = Array.from(cardHeaders).map((header, index) => {
                const title = header.querySelector('.MuiTypography-root')?.textContent ?? "unknown";
                return (
                    <li key={index} style={liStyle}>
                        <Button size="small" onClick={() => handleClick(index)}><small>{title}</small></Button>
                    </li>
                );
            });

            headers.unshift(<li key={"formnav"} style={liStyle}><Button disabled size="small" ><small><strong>Jump To</strong></small></Button></li>)

            setHeaderList(headers);
            setShowNav(true);

        }, 1000)



    }, []);

    return (
        <Box display="inline-flex" justifyContent="center" alignItems="center" sx={{ pt: 2 }}>

            {showNav ?
                <ul style={{ listStyleType: 'none', margin: 0 }}>
                    {headerList}</ul>
                : <CircularProgress
                    sx={{ ml: 3, opacity: .5 }}
                    size={24} />
            }
        </Box>
    );
};

export default FormNavigation;